<template>
    <div class="keyword_formation_box">
        <div class="inform_tit" @click="cancel"> 
            <i class="el-icon-back myback_icon"></i> Back
        </div>
        <div class="inMain_box">
            <div class="informdata_tit">Create New SMS</div>
            <el-form :model="ruleForm" label-position="top" :hide-required-asterisk='true' :rules="rules" ref="ruleForm" label-width="100px" class="information-ruleForm">
                <el-form-item label="Push Time">
                    <div class="checkBox_list">
                        <div class="venue_checkBox" style="width:130px">
                            <span v-if="ruleForm.timeType==0" @click="ruleForm.timeType=1,ruleForm.time=''" class="venue_check"></span>
                            <span v-else class="venue_checked"></span>
                            <span class="venueCheckBox_msg">Now</span>
                        </div>
                        <div class="venue_checkBox">
                            <span v-if="ruleForm.timeType==1"  @click="ruleForm.timeType=0" class="venue_check"></span>
                            <span v-else class="venue_checked"></span>
                            <span class="venueCheckBox_msg">
                                <el-date-picker
                                v-model="ruleForm.time"
                                prefix-icon="el-icon-date"
                                class="venueInformation_input"
                                style="width:100%"
                                type="datetime"
                                :picker-options="pickerOptions"
                                :clearable="false"
                                :disabled="ruleForm.timeType=='1'"
                                format="DD/MM/yyyy HH:mm"
                                placeholder="">
                                </el-date-picker>
                            </span>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="Push Target">
                    <div class="checkBox_list">
                        <div class="venue_checkBox" style="width:130px">
                            <span v-if="ruleForm.targetType==0" @click="ruleForm.targetType=1,ruleForm.target=''" class="venue_check"></span>
                            <span v-else class="venue_checked"></span>
                            <span class="venueCheckBox_msg">All Venues</span>
                        </div>
                        <div class="venue_checkBox">
                            <span v-if="ruleForm.targetType==1"  @click="ruleForm.targetType=0" class="venue_check"></span>
                            <span v-else class="venue_checked"></span>
                            <span class="venueCheckBox_msg">
                                <el-select v-model="ruleForm.target" :disabled="ruleForm.targetType=='1'" placeholder="" class="myVenue_sel">
                                    <el-option
                                    v-for="item in selectOption"
                                    :key="item.id"
                                    :label="item.venueName"
                                    :value="item.id">
                                    </el-option>
                                </el-select>
                            </span>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="Message" prop="cost">
                    <el-input v-model.number="ruleForm.cost" maxlength="1000" type="textarea" resize='none' class="venueInformation_input increaseInput"></el-input>
                </el-form-item>
                <el-form-item class="foot_box">
                    <el-button @click="cancel" class="cardCanBtn">Cancel</el-button>
                    <el-button @click="confirm" class="cardConBtn">Confirm</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import api from '../../api/push';
export default {
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now()-24*60*60*1000;
                }
            },
            rules:{
                cost:[
                    { required: true, message: ' ', trigger: 'blur' }
                ]
            },
            ruleForm:{
                time:'',
                timeType:'1',
                targetType:'1',
                target:'',
                cost:''
            },
            selectOption:[]
        }
    },
    methods: {
        cancel(){
            this.$router.push({path:'/smsList'})
        },
        confirm(){
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    let pat={
                        message:this.ruleForm.cost,
                        pushTarget:this.ruleForm.targetType=='1'?'':this.ruleForm.target,
                        pushTime:this.ruleForm.timeType==0?Date.parse(new Date(this.ruleForm.time))/1000:'',
                        pushType:this.ruleForm.timeType==1?'1':'2',
                    }
                    api.addPush({params:pat,callback:res=>{
                        let {code,message,data}=res.data;
                        if(code==0){
                            this.$router.push({path:'/smsList'})
                        }else{
                            this.$box.alert('', res.data.message, 'error')
                        }
                    }})
                } else {
                    return false;
                }
            });
        }
    },
    mounted() {
        let pat={
            keyword:'',
            pageNum:'1',
            pageSize:'1000'
        }
        api.getVenueList({params:pat,callback:res=>{
            let {code,message,data}=res.data;
            if(code==0){
                this.selectOption=data.list
            }else{
                this.$box.alert('', res.data.message, 'error')
            }
        }})
    },
}
</script>

<style lang="scss">
    .keyword_formation_box{
        .inform_tit{
            height:20px;
            font-size:14px;
            font-family:SFProText-Semibold;
            font-weight:600;
            color:rgba(255,255,255,1);
            line-height:20px;
            cursor: pointer;
            width: 150px;
            margin-bottom: 56px;
        }
        .inMain_box{
            background-color: #2b3444;
            width: 100%;
            box-sizing: border-box;
            padding:50px 20%;
            .informdata_tit{
                text-align: left;
                margin-bottom: 50px;
                height:42px;
                font-size:30px;
                font-family:PingFangSC-Semibold,PingFang SC;
                font-weight:600;
                color:rgba(255,255,255,1);
                line-height:42px;
            }
            .checkBox_list{
                display: flex;
                height: 40px;
                align-items: center;
            }
            .venue_checkBox{
                display: flex;
                align-items: center;
                // margin-right: 218px;
                flex: 1;
                .venue_check{
                    width:17px;
                    height:16px;
                    box-sizing: border-box;
                    background:rgba(43,52,68,1);
                    border-radius:50%;
                    border:1px solid rgba(95,95,95,1);
                    margin-right: 10px;
                    cursor: pointer;
                }
                .venue_checked{
                    width:17px;
                    height:16px;
                    background: url("../../../static/img/Shape.png");
                    background-size: cover;
                    border-radius:50%;
                    background-repeat: no-repeat;
                    margin-right: 10px;
                    cursor: pointer;
                }
                .venueCheckBox_msg{
                    width: 100%;
                    font-size:20px;
                    font-family:PingFang SC;
                    font-weight:400;
                    color:rgba(255,255,255,1);
                    line-height:40px;
                    height: 40px;
                }
            }
            .venueAddtype_btn{
                width:150px;
                height:40px;
                padding: 10px 20px !important;
                background:rgba(43,52,68,1);
                border:1px solid rgba(209,58,144,1);
                font-size:20px;
                font-weight:400;
                color:rgba(209,58,144,1);
            }
            .venueType_box{
                display: inline-block;
                padding:0 20px;
                height:40px;
                line-height: 40px;
                background:rgba(21,28,39,1);
                border:1px solid rgba(95,95,95,1);
                font-size: 20px;
                color: #ffffff;
                vertical-align: top;
                box-sizing: border-box;
                margin-left: 30px;
                position: relative;
                border-radius: 4px;
                .myclose_icon{
                    position: absolute;
                    top: -12px;
                    right: -12px;
                    background-color: #fff;
                    color: #2B3444;
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    font-size: 15px;
                    font-weight: 600;
                    line-height: 20px;
                    text-align: center;
                    cursor: pointer;
                }
            }
        }
    }
    .checked{
        color: #D13A90 !important;
	}
	.increaseIcon{
		line-height: 40px;
		font-size: 18px;
		color: #fff;
		&:first-child{
			margin-right: 20px;
		}
		&:last-child{
			margin-left: 20px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/sms/sms.vue